import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { normalizePath } from 'app/mocks/utils/normalize-path';
import { match, MatchFunction } from 'path-to-regexp';

export function makeEndpointMatcher(
    endpointKey: string,
    apiEndpointService: ApiEndpointService,
): {
    endpointKey: string,
    matcher: MatchFunction<Record<string, string>>;
    urlTemplate: string;
} {
    const rawTemplate = apiEndpointService.getEndpoint(endpointKey);
    if (!rawTemplate) {
        return { endpointKey, matcher: () => false, urlTemplate: '' };
    }

    const templatePath = normalizePath(rawTemplate);
    const matcher = match<Record<string, string>>(templatePath, { decode: decodeURIComponent });

    return { endpointKey, matcher, urlTemplate: rawTemplate };
}
